import UserTable from "/src/features/administration/user/components/UserTable/UserTable";
function UserList() {

    return <UserTable/>
}

export default UserList;